import React from "react";
import {
  FaChevronDown,
  FaChevronUp,
  FaUserMd,
  FaProcedures,
  FaClipboardList,
  FaFileMedicalAlt,
} from "react-icons/fa";

export default function PatientCard({
  patient,
  expandedPatient,
  toggleExpanded,
  handleVisit,
  setPatients,
  navigate,
}) {
  return (
    <div className="bg-white shadow-lg rounded-xl overflow-hidden transition-transform transform hover:scale-105 hover:shadow-2xl m-4">
      <div className="relative">
        {patient.profileImg ? (
          <img
            src={patient.profileImg}
            alt={patient.name}
            className="w-full h-40 object-cover"
          />
        ) : (
          <div className="w-full h-40 flex items-center justify-center bg-gray-200">
            <span className="text-5xl font-bold text-gray-500">
              {patient.name.charAt(0).toUpperCase()}
            </span>
          </div>
        )}
      </div>
      <div className="p-5">
        <h2 className="text-xl font-bold text-gray-900">{patient.name}</h2>
        <div className="text-sm text-gray-600 mt-2 space-y-1">
          <p>Age: {patient.age}</p>
          <p>Gender: {patient.gender}</p>
          <p>Admission Date: {patient.admissionDate}</p>
        </div>
        <button
          className="flex items-center mt-4 text-blue-500 hover:text-blue-700 transition"
          onClick={() => toggleExpanded(patient.id)}
        >
          {expandedPatient === patient.id ? (
            <>
              <FaChevronUp className="mr-2" /> Hide Details
            </>
          ) : (
            <>
              <FaChevronDown className="mr-2" /> View Details
            </>
          )}
        </button>
      </div>
      {expandedPatient === patient.id && (
        <div className="p-4 bg-gray-50 border-t border-gray-200">
          <div className="text-sm text-gray-700 space-y-2">
            <p>
              <span className="font-semibold">Ward:</span> {patient.ward}
            </p>
            <p>
              <span className="font-semibold">Doctor:</span> {patient.doctor}
            </p>
          </div>
          <div className="mt-4">
            <label className="block text-sm font-semibold text-gray-600 mb-1">
              Notes
            </label>
            <textarea
              className="w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
              value={patient.notes}
              onChange={(e) =>
                setPatients((prev) =>
                  prev.map((p) =>
                    p.id === patient.id ? { ...p, notes: e.target.value } : p
                  )
                )
              }
              placeholder="Add notes about the patient..."
            ></textarea>
          </div>
        </div>
      )}
      <div className="p-4 border-t border-gray-200 bg-gray-50">
        {/* Adjust grid columns to always use 2 columns */}
        <div className="grid grid-cols-2 gap-4">
          <button
            onClick={() => navigate(`/new/patient/dashboard/${patient.id}`)}
            className="flex flex-col items-center space-y-1 text-blue-500 border border-blue-500 rounded-lg hover:bg-blue-500 hover:text-white transition p-2"
          >
            <FaUserMd className="text-lg" />
            <span className="text-xs md:text-sm">Dashboard</span>
          </button>

          <button
            onClick={() => handleVisit(patient)}
            className="flex flex-col items-center space-y-1 text-yellow-500 border border-yellow-500 rounded-lg hover:bg-yellow-500 hover:text-white transition p-2"
          >
            <FaClipboardList className="text-lg" />
            <span className="text-xs md:text-sm">Visit</span>
          </button>
          <button
            onClick={() => navigate(`/new/discharge/${patient.id}`)}
            className="flex flex-col items-center space-y-1 text-red-500 border border-red-500 rounded-lg hover:bg-red-500 hover:text-white transition p-2"
          >
            <FaFileMedicalAlt className="text-lg" />
            <span className="text-xs md:text-sm">Discharge</span>
          </button>
          <button
            onClick={() => navigate(`/new/bed-allocation/${patient.id}`)}
            className="flex flex-col items-center space-y-1 text-green-500 border border-green-500 rounded-lg hover:bg-green-500 hover:text-white transition p-2"
          >
            <FaProcedures className="text-lg" />
            <span className="text-xs md:text-sm">Bed Allocation</span>
          </button>
        </div>
      </div>
    </div>
  );
}
